import { createGlobalStyle } from 'styled-components';
import { GlobalCSSVariables } from '@fourthwall/components/dist/assets/GlobalStyle';
// TODO: We need to include old global variables so components have proper styles. This needs to be removed after full migration to new design-system and tokens
export const FallbackGlobalStyles = createGlobalStyle `
  ${GlobalCSSVariables}
`;
